import {FC} from 'react'
import {UserAvatar} from '../../../../../../_metronic/helpers'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

interface IconUserModel {
    name: string
    avatar?: string
    color?: string
    initials?: string
}

type Props = {
    users?: Array<IconUserModel>
    classes?: string
}


const UsersSymbolGroupCard: FC<Props> = ({users = undefined, classes = undefined}) => {
    return (
        <>

        <div className={`symbol symbol-group symbol-hover ${classes}`}>
        {users && users.length > 0 ?
          users.map((user, i) => {
            // Cap baixo (não 12): no card estreito (col-xxl-3), mais de ~8
            // avatares de 35px já não cabem numa linha só e a fileira quebra
            // (ver [[feedback]] visual antes de caber o "+N"). Reduzido pra
            // sempre caber os avatares + o indicador de excedente numa linha.
            if (i < 8) {
              return (
                <OverlayTrigger
                  key={`${i}-${user.name}`}
                  placement='top'
                  overlay={<Tooltip id='tooltip-user-name'>{user.name}</Tooltip>}
                >
                  <div>
                    <UserAvatar
                      name={user.name}
                      avatar={user.avatar}
                      sizeClass='symbol-35px'
                    />
                  </div>
                </OverlayTrigger>
              )
            }
            if (i === 8) {
              return (
                <OverlayTrigger
                  key='more'
                  placement='top'
                  overlay={
                    <Tooltip id='tooltip-users-more'>
                      {users.slice(8).map((user) => user.name).join(', ')}
                    </Tooltip>
                  }
                >
                  {/* Mesma marcação exata do fallback do UserAvatar (mesmos
                      avatares acima quando não tem foto) -- faltava
                      `overflow-hidden` no wrapper e `d-flex align-items-center
                      justify-content-center` no label, então o texto "+N"
                      não centralizava igual ao resto e ficava desalinhado. */}
                  <div>
                    <div className='symbol symbol-35px symbol-circle overflow-hidden'>
                      <span className='symbol-label project-card-avatars-more fw-bolder d-flex align-items-center justify-content-center'>
                        +{users.length - 8}
                      </span>
                    </div>
                  </div>
                </OverlayTrigger>
              )
            }
            return null
          })
        :
        null
        }

        </div>

        </>
    )
}

export {UsersSymbolGroupCard}



